import React, { useEffect, useState } from 'react';
import { fetchJson } from '../apiBase';
import ParentStudentPageLayout from './ParentStudentPageLayout';

const dateFormatter = new Intl.DateTimeFormat('tr-TR', {
  day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Istanbul',
});
const pageButtonStyle = { border:'1px solid #a9ddd8', borderRadius:10, background:'#fff', color:'#0f766e',
  padding:'9px 14px', fontFamily:'inherit', fontWeight:800, cursor:'pointer' };

export default function PointsPage() {
  const requestedId = new URLSearchParams(window.location.search).get('student_id') || '';
  const [students, setStudents] = useState([]);
  const [studentId, setStudentId] = useState(requestedId);
  const [points, setPoints] = useState(null);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (window.location.pathname.startsWith('/admin/')) return;
    let active = true;
    fetchJson('/parent/allowed-students')
      .then(async (res) => res.ok ? res.json() : null)
      .then((body) => {
        if (!active) return;
        const items = body?.items || [];
        setStudents(items);
        if (!requestedId && items.length) setStudentId(String(items[0].student_id));
        else if (!requestedId) {
          setError('Gösterilecek öğrenci bulunamadı.');
          setLoading(false);
        }
      })
      .catch(() => {
        if (active) {
          setError('Öğrenciler yüklenemedi.');
          setLoading(false);
        }
      });
    return () => { active = false; };
  }, [requestedId]);

  useEffect(() => {
    if (!studentId) return;
    let active = true;
    setLoading(true);
    setError('');
    setPoints(null);
    const query = new URLSearchParams({ student_id: studentId, offset: String(offset), limit: '30' });
    fetchJson(`/parent/points?${query}`)
      .then(async (res) => {
        const body = await res.json();
        if (!res.ok) throw new Error(body?.detail || 'Puanlar yüklenemedi.');
        return body;
      })
      .then((body) => { if (active) setPoints(body); })
      .catch((err) => { if (active) setError(err.message || 'Puanlar yüklenemedi.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [studentId, offset]);

  const selectedStudent = students.find((student) => String(student.student_id) === String(studentId));

  return (
    <ParentStudentPageLayout studentId={studentId} studentFallback={selectedStudent} students={students} pointBalance={points?.available_points} activePage="points">
      <main style={{ color: '#0f1e56' }}>
        <h1 style={{ margin: '16px 0 8px', fontSize:34 }}>Puanlarım</h1>
        <p style={{ margin: '0 0 20px', color: '#475569' }}>Yaptıklarınla kazandığın DANDU puanları.</p>
        {error && <p role="alert" style={{ padding: 16, borderRadius: 12, background: '#fef2f2', color: '#991b1b' }}>{error}</p>}
        {loading && <p>Öğrenci puanları yükleniyor...</p>}
        {!loading && points && (
          <>
            <section style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 24 }}>
              <div style={{ padding: 22, borderRadius: 20, background: 'linear-gradient(130deg, #0f766e, #14b8a6)', color: '#fff', boxShadow:'0 8px 22px rgba(15,118,110,0.16)' }}>
                <div style={{ fontWeight: 700 }}>Kullanılabilir puan</div>
                <strong style={{ display: 'block', marginTop: 10, fontSize: 42 }}>{points.available_points}</strong>
              </div>
              <div style={{ padding: 22, borderRadius: 20, background: '#fff', border: '1px solid #d6e8ed' }}>
                <div style={{ fontWeight: 700 }}>Toplam kazanılan</div>
                <strong style={{ display: 'block', marginTop: 10, fontSize: 42 }}>{points.total_earned_points}</strong>
              </div>
            </section>
            <section style={{ padding: '20px 22px', borderRadius: 20, background: '#fff', border: '1px solid #d6e8ed', boxShadow:'0 8px 22px rgba(29,65,107,0.06)' }}>
              <h2 style={{ margin: '0 0 14px', fontSize: 22 }}>Puan geçmişi</h2>
              {points.transactions.length === 0 && <p style={{ color: '#64748b' }}>Henüz puan kazanımı yok.</p>}
              {points.transactions.map((item) => (
                <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '12px 0', borderTop: '1px solid #e2e8f0' }}>
                  <div>
                    <div style={{ fontWeight: 700 }}>{item.label}</div>
                    {item.note && <div style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{item.note}</div>}
                    {item.activity_title && <div style={{ overflowWrap: 'anywhere' }}>{item.activity_title}</div>}
                    <small style={{ color: '#64748b' }}>{dateFormatter.format(new Date(item.occurred_at))}</small>
                  </div>
                  <strong style={{ color: item.amount > 0 ? '#15803d' : '#b91c1c', whiteSpace: 'nowrap' }}>{item.amount > 0 ? '+' : ''}{item.amount}</strong>
                </div>
              ))}
            </section>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
              <button type="button" style={pageButtonStyle} disabled={offset === 0} onClick={() => setOffset(Math.max(0, offset - 30))}>Önceki</button>
              <button type="button" style={pageButtonStyle} disabled={!points.has_more} onClick={() => setOffset(offset + 30)}>Sonraki</button>
            </div>
          </>
        )}
      </main>
    </ParentStudentPageLayout>
  );
}
